import React from 'react';
import InputMinMax from '@lib/components/Input/InputMinMax';
import { defaultProps } from '../types';

export default function MinMaxPreview() {
  return <InputMinMax {...defaultProps} value={undefined} />;
}
